/** Example format shown in the share-code import field (not validated against this exact value). */
export const SHARE_CODE_PLACEHOLDER = "A1B2C3D4";
